import React, { useEffect, useState } from 'react';

import { AgentModel, AgentSettingsInput, TraceProviderModel, TraceSettings } from '../../../../../gamma-api';
import Settings from '../../../../components/Settings';

export interface ITracingTabProps {
  agent?: AgentModel;
  agentTraceProvider?: TraceProviderModel;
  onSave?: (
    traceSettings?: TraceSettings,
    traceProvider?: TraceProviderModel,
    agentSettings?: AgentSettingsInput
  ) => Promise<void>;
}

const TracingTab: React.FC<ITracingTabProps> = ({ agent, agentTraceProvider, onSave }) => {
  const [traceSettings, setTraceSettings] = useState<TraceSettings | undefined>(agent?.trace);
  const [traceProvider, setTraceProvider] = useState<TraceProviderModel | undefined>(agentTraceProvider);
  const [agentSettings, setAgentSettings] = useState<AgentSettingsInput | undefined>(agent?.settings);

  const onTracingSave = async () => {
    await onSave?.(traceSettings, traceProvider, agentSettings);
  };

  const onTracingSettingsChange = (traceSettings?: TraceSettings, traceProvider?: TraceProviderModel) => {
    setTraceSettings(traceSettings);
    setTraceProvider(traceProvider);
  };

  const onAgentSettingsChange = (settings: AgentSettingsInput) => {
    setAgentSettings(settings);
  };

  const onAgentAndAgentTraceProviderPropsChange = () => {
    setTraceSettings(agent?.trace);
    setTraceProvider(agentTraceProvider);
    setAgentSettings(agent?.settings);
  };
  useEffect(onAgentAndAgentTraceProviderPropsChange, [agent, agentTraceProvider]);

  return (
    <Settings.Tracing
      agentSettings={agentSettings}
      traceProvider={traceProvider}
      traceSettings={traceSettings}
      onAgentSettingsChange={onAgentSettingsChange}
      onSave={onTracingSave}
      onTraceSettingsChange={onTracingSettingsChange}
    />
  );
};

export default TracingTab;
